export default "__VITE_ASSET__H5j8oTUn__"